import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import SuccessIcon from "shared/icons/status-icons/success-icon.svg?react";
import FailedIcon from "shared/icons/status-icons/fail-icon.svg?react";
import { FC } from "react";
import { useSettingsController } from "views/settings-developers/controller";
import { PropertyManagementSystem } from "types/landlord/partner";
import { PMSNames } from "views/settings-developers/constants";

type Props = {
  isActive: boolean;
  isListed?: boolean;
  withText?: boolean;
  withListedInfo?: boolean;
};

type ListedComponentProps = Pick<Props, "isListed">;

const ListedComponent = ({ isListed }: ListedComponentProps) => {
  return (
    <div>
      <div className="relative">
        {/*dashed line*/}
        <div className="absolute border-l border-content-100 left-2.5 border-dashed h-5 -top-2.5" />
        {/*circle*/}
        <div className="absolute transform -translate-y-1/2 left-7 top-2.5 size-1.5 bg-content-100 rounded-full" />
        {/*dashed line*/}
        <div className="absolute top-1/2 transform -translate-y-1/2 left-3 top-2.5 border-dashed border-content-100 border-t w-4" />
      </div>

      <div className="flex gap-2 place-items-center mt-3 ml-10">
        {isListed ? (
          <SuccessIcon className="w-5 text-primary-500" />
        ) : (
          <FailedIcon className="text-alpha-100 w-5" />
        )}

        <p className="text-content-1000 font-medium text-sm">
          Show unit on portfolio page
        </p>
      </div>
    </div>
  );
};

export const AllowOrDisallowApplications: FC<Props> = ({
  isActive,
  withText = true,
  isListed = false,
  withListedInfo = false
}) => {
  const { propertyManagementSystem } = useSettingsController();

  const isAppfolio =
    propertyManagementSystem === PropertyManagementSystem.APPFOLIO;

  return (
    <Tooltip>
      <TooltipTrigger>
        {isActive ? (
          <div className="flex gap-2 place-items-center">
            <SuccessIcon className="w-5 text-primary-500" />
            {withText ? (
              <p className="text-content-1000 font-medium text-sm">
                Allow applications
              </p>
            ) : null}
          </div>
        ) : (
          <div className="flex gap-2 place-items-center">
            <FailedIcon className="text-alpha-100 w-5" />
            {withText ? (
              <p className="text-content-1000 font-medium text-sm">
                Don&apos;t allow applications
              </p>
            ) : null}
          </div>
        )}

        {withListedInfo ? <ListedComponent isListed={isListed} /> : null}
      </TooltipTrigger>
      <TooltipContent className="max-w-[370px] rounded-lg z-[50] border bg-alpha-800 p-4 text-sm text-content-1000-inverted">
        {isAppfolio
          ? 'You can allow/disallow applicants to submit applications by setting "Yes" or "No" under the "Marketing Information" section in your PMS.'
          : `Application submission status is automatically synchronized with ${PMSNames[propertyManagementSystem as PropertyManagementSystem]} listing status`}
      </TooltipContent>
    </Tooltip>
  );
};
